<template lang="pug">
include /mixins
modal-wrapper(
  :info='{}'
  @close='$emit("close")'
)
    +b.ds-panel--space_md
      +e.element--offset_vertical 
        +b.ds-caption.--size_2lg.--size_3xl-custom-xl.--semibold.P {{ info.campaign.campaign_title }}
    +b.line-h--light.tt-space_mb--6
    +b.g-row--space_xl-mac.--appearance_spaced
      +b.g-cell.g-cols--12.--8-xl.order-1-till-xl
        +b.g-row--space_xl-mac.--appearance_spaced
          +b.g-cell.g-cols--12.--6-md.--4-xl(
            v-for='variant in info.set'
          )
            sales-cart-variant-card(
              :classes="'product-set-card--transparent product-set-card--horizontal'",
              :variant='variant'
              :key='variant.id'
              :is-sale-info='true'
              @updateCart='updateCart($event, variant)'
            )
      +b.g-cell.g-cols--12.--4-xl.tt-space_mb--5-till-xl
        template(v-if='info.campaign.discount_summ_amount')
          +b.tt-card-product-page-inner.--light-bg.--full-h.card-product-inner
            row(space="none" appearance="column" class="full-h")
              template(v-if='info.campaign.discount_summ_amount || info.campaign.discount_summ_amount')
                cell(cols="12")
                  table
                    tr
                      td
                        +b.ds-caption--size_2md.--size_3md-xl.--medium.tt-space_mr--2.tt-space_mr--8-xl.P {{ _('Стоимость товаров по отдельности') }}
                      td
                        +b.ds-caption--size_2md.--size_3md-xl.--semibold.--appearance_right.--appearance_nowrap.P(
                          v-html='getSplittedHtml(info.campaign.price_without_campaign)'
                        )
                cell(cols="12")
                  +b.line-h.--light.tt-space_mb--6.tt-space_mt--6
                  table
                    tr
                      td
                        +b.ds-caption--size_2md.--size_3md-xl.--medium.tt-space_mr--2.tt-space_mr--8-xl.P {{ _('Скидка на комплект') }}
                      td
                        +b.ds-caption--size_2md.--size_3md-xl.--semibold.--appearance_right.--appearance_nowrap.P {{ info.campaign.complect_discount_percent }}{{ _('%') }}
              template(v-if='info.campaign.discount_summ_amount')
                cell(cols="12" class="flex_1")
                  +b.line-h.--light.tt-space_mb--6.tt-space_mt--6
                  table
                    tr
                      td
                        +b.ds-caption--size_2md.--size_3md-xl.--medium.tt-space_mr--2.tt-space_mr--8-xl.P {{ _('Купив этот комплект, вы экономите') }}
                      td
                        +b.ds-caption--size_2md.--size_3md-xl.--semibold.--appearance_right.--appearance_nowrap.P(
                          v-html='getSplittedHtml(info.campaign.discount_summ_amount)'
                        )
                  +b.tt-space_mb--10.is-visible-xl
              template(v-if='info.campaign.discount_summ_amount || info.campaign.discount_summ_amount')
                cell(cols="12" class="is-visible-xl")
                  +b.tt-space_mt--10
                  row(
                  justify='between'
                  align='start',
                )
                    cell(
                      cols='4'
                    )
                      +b.ds-caption.--size_2md.--size_2md.--size_3md-xl-xl.--semibold.--lh_25.P {{ _('Вы заплатите') }}
                    cell(
                      cols='8'
                    )
                      row
                        cell(
                          cols='12'
                        )
                          +b.ds-caption.--size_3md.--size_lg-xl.--appearance_right.--color_grey.--semibold.P(v-html='getSplittedHtml(info.campaign.price_with_discount)')
                        cell(
                          cols='12'
                        )
                          ui-currency-converter.ds-caption--appearance_right(
                            :price='info.campaign.price_with_discount'
                            :site-currency="current_site_currency"
                            :national-currency="national_currency"
                            :national-currency-symbol="national_currency_symbol"
                          ) 
          //- template(v-if='info.gifts')
          //-   +b.g-row--align_center
          //-     +b.g-cell.g-cols--narrow.relative
          //-       +b.gift-image(
          //-         src="/static/img/gift-small.svg"
          //-       )
          //-     +b.g-cell.g-cols--auto
          //-       +b.ds-caption--size_2md.--size_3md-xl.--size_2md.--size_3md-xl-xl.--semibold.A.tt-link--variant_start {{ _('Подарунок до цього комплекту') }}
          //-   //- pre {{ info }}
          //-   template(v-for='set in info.gifts')
          //-     //- pre {{ set }}
          //-     gift-change-variants(
          //-       :id="set.base.id"
          //-       :promise="pr"
          //-       :count="set.base.parameters.gift_amount"
          //-       :set="set ? set : {}"
          //-       :is-simple="true"
              )
        template(v-if='info.campaign.price_without_campaign && !info.campaign.discount_summ_amount')
          +b.tt-card-product-page-inner.--light-bg.--full-h.card-product-inner.is-visible-xl
            row(space="none" appearance="column" class="full-h" justify="end")
              cell(cols="12")
                row(
                  justify='between'
                  align='start',
                )
                  cell(
                    cols='4'
                  )
                    +b.ds-caption.--size_2md.--size_2md.--size_3md-xl-xl.--semibold.P {{ _('Стоимость комплекта') }}
                  cell(
                    cols='8'
                  )
                    row
                      cell(
                        cols='12'
                      )
                        +b.ds-caption.--size_3md.--size_lg-xl.--appearance_right.--color_grey.--semibold.P(v-html='getSplittedHtml(info.campaign.price_without_campaign)')
                      cell(
                        cols='12'
                      )
                        ui-currency-converter.ds-caption--appearance_right(
                          :price='info.campaign.price_without_campaign'
                          :site-currency="current_site_currency"
                          :national-currency="national_currency"
                          :national-currency-symbol="national_currency_symbol"
                        )
    +b.tt-packages-view-bottom.is-disable-xl
      +b.tt-space_pt--6
      template(v-if='info.campaign.price_without_campaign && !info.campaign.discount_summ_amount')
        row(space="none" appearance="column" class="full-h" justify="end")
          cell(cols="12")
            row(
              justify='between'
              align='start',
            )
              cell(
                cols='4'
              )
                +b.ds-caption.--size_2md.--size_2md.--size_3md-xl-xl.--semibold.P {{ _('Стоимость комплекта') }}
              cell(
                cols='8'
              )
                row
                  cell(
                    cols='12'
                  )
                    +b.ds-caption.--size_3md.--size_lg-xl.--appearance_right.--color_grey.--semibold.P(v-html='getSplittedHtml(info.campaign.price_without_campaign)')
                  cell(
                    cols='12'
                  )
                    ui-currency-converter.ds-caption--appearance_right(
                      :price='info.campaign.price_without_campaign'
                      :site-currency="current_site_currency"
                      :national-currency="national_currency"
                      :national-currency-symbol="national_currency_symbol"
                    )
      template(v-if='info.campaign.discount_summ_amount || info.campaign.discount_summ_amount')
        row(
          justify='between'
          align='start',
        )
            cell(
              cols='4'
            )
              +b.ds-caption.--size_2md.--size_2md.--size_3md-xl-xl.--semibold.--lh_25.P {{ _('Вы заплатите') }}
            cell(
              cols='8'
            )
              row
                cell(
                  cols='12'
                )
                  +b.ds-caption.--size_3md.--size_lg-xl.--appearance_right.--color_grey.--semibold.P(v-html='getSplittedHtml(info.campaign.price_with_discount)')
                cell(
                  cols='12'
                )
                  ui-currency-converter.ds-caption--appearance_right(
                    :price='info.campaign.price_with_discount'
                    :site-currency="current_site_currency"
                    :national-currency="national_currency"
                    :national-currency-symbol="national_currency_symbol"
                  )
</template>

<script>
import GiftChangeVariants from '@app/Cart/GiftChangeVariants'

export default {
  props: ['info'],
  name: 'SetViewDetailed',
  data() {
    return {
      current_site_currency: window.current_site_currency,
      national_currency: window.national_currency,
      national_currency_symbol: window.national_currency_symbol,
      currency: window.currency,
    }
  },
   components: {
    GiftChangeVariants,
  },
  computed: {
    firstSet(set) {
      if (!set) return {}
      return set[0]
    },
  },
  methods: {
    pr(arg) {new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg)
          return
        }
        reject(new Error('Promise is rejected'))
      }).then(res => {
        console.log("🚀 ~ res:", res)
        // this.getCart()
      })
  },}
}
</script>
